// UPPY styles
import coreStyle from '@uppy/core/dist/style.min.css';
import dragDropStyle from '@uppy/drag-drop/dist/style.css';
import fileInputStyle from '@uppy/file-input/dist/style.min.css';
import statusBarStyle from '@uppy/status-bar/dist/style.min.css';

const AvatarStyle = {
  ...coreStyle,
  ...dragDropStyle,
  ...fileInputStyle,
  ...statusBarStyle,
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  imgContainer: {
    position: 'relative',
  },
  avatarImg: {
  },
  mainImg: {
    borderRadius: '50%',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  agLogo: {
    position: 'absolute',
    right: 0,
    width: '40px',
    height: '40px',
    bottom: '-10px',
    zIndex: '999',
  },
  uppyCompStyles: {
    position: 'absolute',
    '&>div': {
      width: '100%',
      height: '100%',
    },
    '& .uppy-DragDrop--is-dragdrop-supported': {
      backgroundColor: 'rgba(255,255,255,.85) !important',
      '&>div': {
        padding: '0 16px !important',
      },
      '& svg': {
        display: 'none !important',
      },
      '& .uppy-DragDrop-label': {
        fontSize: '1em !important',
      },
    },
  },
  isAvatar: {
    '& .uppy-DragDrop--is-dragdrop-supported': {
      borderRadius: '50% !important',
    },
  },
  isImage: {
    '& .uppy-DragDrop--is-dragdrop-supported': {
      borderRadius: '0 !important',
    },
  },
};

export default AvatarStyle;
